import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`/api/users/reset-password/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Reset link is invalid or expired.');
      } else {
        setSuccess('Password reset successful. Redirecting to login...');
        setTimeout(() => navigate('/login'), 2500);
      }
    } catch {
      setError('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      fluid
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)',
      }}
    >
      <Row className="w-100 justify-content-center">
        <Col xs={11} sm={8} md={6} lg={4}>
          <Card
            className="border-0 shadow-lg rounded-4"
            style={{
              backdropFilter: 'blur(12px)',
              background: 'rgba(255, 255, 255, 0.95)',
            }}
          >
            <Card.Body className="p-4 p-md-5">
              <div className="text-center mb-4">
                <h2 className="fw-bold mb-2">Set New Password</h2>
                <p className="text-muted small">
                  Choose a strong password you haven’t used before
                </p>
              </div>

              {error && (
                <Alert variant="danger" className="rounded-3">
                  {error}
                </Alert>
              )}

              {success && (
                <Alert variant="success" className="rounded-3">
                  {success}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold small">
                    New password
                  </Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    className="rounded-3 py-2"
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold small">
                    Confirm new password
                  </Form.Label>
                  <Form.Control
                    type="password"
                    value={confirmPassword}
                    required
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="••••••••"
                    className="rounded-3 py-2"
                  />
                </Form.Group>

                <Button
                  type="submit"
                  size="lg"
                  className="w-100 rounded-pill fw-semibold"
                  disabled={loading}
                  style={{
                    background:
                      'linear-gradient(135deg, #4dabf7, #1c7ed6)',
                    border: 'none',
                  }}
                >
                  {loading ? 'Updating…' : 'Update Password'}
                </Button>
              </Form>

              <div className="text-center mt-4">
                <Link
                  to="/login"
                  className="fw-semibold text-decoration-none"
                  style={{ color: '#1c7ed6' }}
                >
                  Back to login
                </Link>
              </div>
            </Card.Body>
          </Card>

          <p className="text-center text-light small mt-4 opacity-75">
            One-time secure link • Expires automatically
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;
